<template>
  <div class="page">
    <div class="container-general">
      <div class="container">
        <Home @onClickViewProducts="onClickViewProducts" :show="!showHero && !showForm && !showOverview" />

        <!-- <HeroNavigation
          @filterProducts="filterProducts"
          @clickNavigation="handleClickNavigation"
          @clickTest="handleClickNavigation"
          @handleUserChoices="handleUserChoices"
          @setMenuActive="handleSetMenuActive"
          :menuActive="menuActive"
          :userChoices="userChoices"
          :show="showHero"
          :quantityFilteredProducts="quantityFilteredProducts"
          :products="products"
        /> -->

        <HeroNavigation @filterProducts="filterProducts" @clickNavigation="handleClickNavigation"
          @handleUserChoices="handleUserChoices" @setMenuActive="handleSetMenuActive" :menuActive="menuActive"
          :userChoices="userChoices" :show="showHero" :quantityFilteredProducts="quantityFilteredProducts"
          :products="products" />

        <Form @backToTop="onClickBackToTop" :show="showForm" :selectedTv="userChoices.selectedTv"
          @onClickOpenForm="onClickOpenForm" :soundbar="suggestedSoundbar" />

        <Overview :show="showOverview" @onClickViewProducts="onClickViewProducts" @onClickBackToTop="onClickBackToTop"
          @handleUserChoices="handleUserChoices" :userChoices="this.userChoices" :showFinalFilters="showFinalFilters" />

        <!-- <ProductsTable
          :products="products"
          :show="!showForm"
          :title="tableTitle"
          :highlights="highlights"
          @onClickOpenForm="onClickOpenForm"
          :goSmooth="goSmooth"
          :smallMarginTop="this.showOverview"
          :menuActive="menuActive"
          :showOverview="showOverview"
        /> -->

        <div id="scrollToProductTable"></div>

        <ProductsTable v-if="products" :products="products" :show="showProductTable" :title="tableTitle"
          :highlights="highlights" @onClickOpenForm="onClickOpenForm" :goSmooth="goSmooth"
          :smallMarginTop="this.showOverview" :menuActive="menuActive" :showOverview="showOverview"
          :userChoices="userChoices.passionSelected" :forceRerenderProductsTable="forceRerenderProductsTable" />

        <!-- <div class="divider"></div> -->

        <!-- <Shopkeepers id="shop" /> -->

        <!-- <div class="legal legal-cupom" id="legalText">
          <div v-show="showForm" class="legal-coupon-mechanic" :class="{ legalCouponMechanicInForm: showForm }">
            <p>
              Cupons limitados e válidos diariamente ou até enquanto durarem os
              estoques, preços e condições de pagamento sujeitos a alteração sem
              aviso prévio. Cupom válido para primeira compra, não cumulativo com
              outros cupons.
            </p>
          </div>
        </div> -->

        <div v-show="showProductTable" class="legal">
          <p>
            <sup>1</sup> 144Hz nas TVs de 43" e 50"; 120Hz nas TVs de 55" e 65"
          </p>
          <p><sup>2</sup> 120Hz nas TVs de 55" e 65"; 60Hz na TV de 50"</p>
          <p>
            <sup>3</sup> HDMI 2.1 nas TVs de 55" e 65"; HDMI 2.0 na TV de 50"
          </p>
          <p><sup>4</sup> Exceto na TV de 32", que é Full HD</p>
          <p><sup>5</sup> Exceto na TV de 32"</p>
          <p>
            <sup>6</sup> 60Hz nas TVs de 32", 43" e 50"; 120Hz nas TVs 55", 65",
            75" e 85"
          </p>
          <p><sup>7</sup> Exceto nas TVs de 32", 43" e 50"</p>
          <p>
            <sup>8</sup> Som em movimento virtual nas TVs de 32", 43" e 50"; Som
            em movimento nas TVs de 55", 65", 75" e 85"
          </p>
          <p>
            <sup>9</sup> 20W RMS nas TVs de 32", 43" e 50"; 40W RMS nas TVs de
            55", 65", 75" e 85"
          </p>
          <p><sup>10</sup> Para a Bixby</p>
          <p>
            <sup>11</sup> Alto nas TVs de 43" e 50"; Muito Alto nas TVs de 55" e
            65"
          </p>
          <p><sup>12</sup> 40W na TV de 50"; 60W nas TVs de 55" e 65"</p>
          <p>
            <sup>13</sup> 20W na TV de 43"; 40W na TV de 50"; 60W nas TVs de 55"
            e 65"
          </p>
        </div>

        <div class="legal legal-big-text" id="legalText">
          <p class="big_legal">
            <img src="./assets/polo-manaus.png" width="67" alt="" align="left" />
            Imagens meramente ilustrativas. <br />
            Amazon, Alexa, Prime Video e todos os logotipos relacionados são marcas registradas da <a
              href="https://www.amazon.com" target="_blank">Amazon.com </a>Inc., ou
            de suas afiliadas.
          </p>
        </div>


      </div>

    </div>
  </div>
</template>

<script>
import HeroNavigation from "./pages/HeroNavigation.vue";
import ProductsTable from "./pages/ProductsTable.vue";
import Home from "./pages/Home.vue";
import Form from "./pages/Form.vue";
import Overview from "./pages/Overview.vue";

// import Shopkeepers from "./pages/Shopkeepers.vue";

import {
  getFeaturesByPassion,
  getProducts,
  groupProducts,
} from "./utils/dataHandler";
import products from "./constants/products";
import rooms from "./constants/rooms";
import soundbar from "./constants/soundbar";


import 'vue-select/dist/vue-select.css';

export default {
  name: "App",
  components: {
    HeroNavigation,
    ProductsTable,
    Home,
    Form,
    Overview,

    // Shopkeepers
  },
  data() {
    return {
      products: [],
      sizes: [],
      highlights: [],
      quantityFilteredProducts: 0,
      minPrice: 0,
      maxPrice: 0,
      showHome: false,
      showHero: true,
      showOverview: false,
      showForm: false,
      showProductTable: false,
      showFinalFilters: false,
      tableTitle: { title: "Todos os modelos" },
      menuActive: 1,
      userChoices: {
        roomSelected: rooms[0],
        passionSelected: "",
        featureSelected: "",
      },
      suggestedSoundbar: {},
      forceRerenderProductsTable: 0,
    };
  },
  created() {
    window.addEventListener('hashchange', this.onHashChanged);
    window.dispatchEvent(new Event('hashchange'));
  },
  mounted() {
    let productsArray = [];
    Object.keys(products).forEach((key) => productsArray.push(products[key]));
    this.products = groupProducts(productsArray);
  },
  methods: {
    onHashChanged() {
      if (location.hash.startsWith("#/home")) {
        this.onClickDiscover();
      }
    },
    sendAnalytics(tag) {
      window.click_s_code("o", `home:${tag}`);
    },
    filterProducts({ filter }) {

      const { filteredProducts, sizes, price } = getProducts(filter);
      this.products = filteredProducts;
      this.sizes = sizes;

      this.minPrice = price.min;
      this.maxPrice = price.max;
      this.quantityFilteredProducts = this.products.length;

      sessionStorage.setItem("min", this.minPrice);
      sessionStorage.setItem("max", this.maxPrice);

      let displayNameProducts = "";

      filteredProducts.map((product) => {
        if (displayNameProducts.length === 0) {
          displayNameProducts = product.displayName;
        } else {
          displayNameProducts = `${displayNameProducts}, ${product.displayName}`;
        }
      });
    },
    onClickViewProducts() {
      this.showProductTable = true;

      var productTable = document.getElementById("scrollToProductTable")

      productTable.scrollIntoView({
        behavior: "smooth",
      })
    },
    onClickDiscover() {
      this.showProductTable = false;
      this.showHero = false;
      this.showForm = false;
      this.showHome = true;
      // this.menuActive = 1;

      window.scrollTo({ top: 0, behavior: "smooth" });

    },
    handleClickNavigation(operation) {


      // Clear inch and price previously selected

      if (operation === "goBack") {
        switch (this.menuActive) {
          case 2:
            delete this.userChoices.inchSelected;
            delete this.userChoices.priceSelected;
            break;

          case 3:
            delete this.userChoices.inchSelected;
            delete this.userChoices.priceSelected;
            break;

          // default:
          //   this.userChoices.inchSelected;
          //   this.userChoices.priceSelected;
          //   break;
        }
      }

      if (operation === "forward" || operation === "goBack") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      this.tableTitle =
        this.menuActive >= 1 && this.menuActive <= 3
          ? {
            title: "Estamos quase descobrindo qual é a sua TV ideal",
            class: "almostFindingOut",
          }
          : { title: "Todos os modelos" };

      if (
        (this.menuActive === 4 && operation === "forward") ||
        (this.quantityFilteredProducts === 1 &&
          operation === "forward" &&
          this.sizes.length === 1)
      ) {
        // let modifiedArray = this.products;

        // modifiedArray.forEach((product, index) => {
        //   if (index === 0) {
        //     Object.assign(product, {
        //       perfectForYou: true,
        //     });
        //   }
        // });

        // if (modifiedArray.length > 1) {

        //   let bestCostBenefit = modifiedArray[0];
        //   let indexOfBestCostBenefit;

        //   // FIND BEST COST BENEFIT
        //   modifiedArray.map((product) => {
        //     if (Number(product.price) < Number(bestCostBenefit.price)) {
        //       bestCostBenefit = product;
        //     }
        //   });

        //   //SET BEST COST BENEFIT AND PERFECT FOR YOU
        //   modifiedArray.forEach((product) => {
        //     if (product.sku === bestCostBenefit.sku && !product.perfectForYou) {
        //       Object.assign(product, {
        //         bestCostBenefit: true,
        //       });
        //     }
        //   });

        //   //RE-ORDER ARRAY
        //   if (bestCostBenefit.sku !== modifiedArray[0].sku) {
        //     indexOfBestCostBenefit = modifiedArray.findIndex(
        //       (product) => product.sku === bestCostBenefit.sku
        //     );
        //     modifiedArray.splice(indexOfBestCostBenefit, 1);
        //     modifiedArray.splice(1, 0, bestCostBenefit);
        //   }

        // }

        this.products = this.findPerfectForYouAndBestCostBenefit();
        this.showProductTable = true;
        this.showHero = false;
        this.showOverview = true;
        this.tableTitle = { title: "Confira o seu resultado" };
        this.showFinalFilters = true;
        this.quantityFilteredProducts = 0;

        // window.scrollTo({ top: 0, behavior: "smooth" });
      }

      if (this.menuActive === 1 && operation === "goBack") {
        (this.userChoices = {
          roomSelected: rooms[0],
          passionSelected: "",
          featureSelected: "",
        }),
          this.products.forEach((product) => {
            product.bestCostBenefit = false;
            product.perfectForYou = false;
          });

        let productsArray = [];
        Object.keys(products).forEach((key) =>
          productsArray.push(products[key])
        );
        this.products = groupProducts(productsArray);

        this.tableTitle = { title: "Todos os modelos" };
        this.showOverview = false;
        this.showHero = false;
        this.showProductTable = false;
        window.location.replace('#/home');
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      this.menuActive =
        operation === "goBack" ? this.menuActive - 1 : this.menuActive + 1;

    },

    handleSetMenuActive(value) {
      this.menuActive = value
    },

    onClickBackToTop(screen) {

      if (screen === "form") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      if (screen === "overview") {
        (this.userChoices = {
          roomSelected: rooms[0],
          passionSelected: "",
          featureSelected: "",
        }),
          this.products.forEach((product) => {
            product.bestCostBenefit = false;
            product.perfectForYou = false;
          });

        this.menuActive = 1;

        window.scrollTo({ top: 0, behavior: "smooth" });

        let productsArray = [];
        Object.keys(products).forEach((key) =>
          productsArray.push(products[key])
        );
        this.products = groupProducts(productsArray);

        this.tableTitle = { title: "Todos os modelos" };
        this.quantityFilteredProducts = productsArray.length;
        this.showForm = false;
        this.showOverview = false;
        this.showHero = true;
        this.showProductTable = false;
        this.showFinalFilters = false;
      } else {
        this.showForm = false;
        this.showOverview = true;
        this.showHero = false;
        this.showProductTable = true;
      }
    },
    onClickOpenForm(selectedTv) {

      this.userChoices = {
        ...this.userChoices,
        selectedTv,
      };

      this.suggestedSoundbar = soundbar[selectedTv.displayName];


      this.showHero = false;
      this.showOverview = false;
      this.showForm = true;
      this.showProductTable = false;

      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleUserChoices({ filter, choices, finalFilter }) {

      if (
        choices.featureSelected &&
        this.userChoices.featureSelected != choices.featureSelected
      ) {
        delete this.userChoices.inchSelected;
        delete this.userChoices.priceSelected;
      }

      this.userChoices = {
        ...this.userChoices,
        ...choices,
      };

      if (Object.keys(choices).length === 1 && choices["roomSelected"]) return;

      this.filterProducts({ filter });

      if (filter.passion) {
        const passion = getFeaturesByPassion(filter.passion);

        if (filter.feature) {
          const feature = passion.featuresByPassion.find(
            (feature) => feature.name === filter.feature
          );
          this.highlights = feature.highlights;
        } else {
          const highlights = [];
          passion.featuresByPassion.forEach((feature) => {
            feature.highlights.forEach((highlight) => {
              if (!highlights.includes(highlight)) {
                highlights.push(highlight);
              }
            });
          });

          this.highlights = highlights;
        }
      }

      if (finalFilter) {
        this.products.forEach((product) => {
          product.bestCostBenefit = false;
          product.perfectForYou = false;
        });

        this.products = this.findPerfectForYouAndBestCostBenefit();
        this.forceRerenderProductsTable += 1;
      }
    },
    goSmooth(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
      });
    },
    findPerfectForYouAndBestCostBenefit() {
      let arrayWithPerfectForYouAndBestCostBenefit = this.products;

      Object.assign(arrayWithPerfectForYouAndBestCostBenefit[0], {
        perfectForYou: true,
      });

      if (arrayWithPerfectForYouAndBestCostBenefit.length > 1) {

        let bestCostBenefit = arrayWithPerfectForYouAndBestCostBenefit[0];
        let indexOfBestCostBenefit;

        // FIND BEST COST BENEFIT
        arrayWithPerfectForYouAndBestCostBenefit.map((product) => {
          if (Number(product.price) < Number(bestCostBenefit.price)) {
            bestCostBenefit = product;
          }
        });

        //SET BEST COST BENEFIT AND PERFECT FOR YOU
        arrayWithPerfectForYouAndBestCostBenefit.forEach((product) => {
          if (product.sku === bestCostBenefit.sku && !product.perfectForYou) {
            Object.assign(product, {
              bestCostBenefit: true,
            });
          }
        });

        //RE-ORDER ARRAY
        if (bestCostBenefit.sku !== arrayWithPerfectForYouAndBestCostBenefit[0].sku) {
          indexOfBestCostBenefit = arrayWithPerfectForYouAndBestCostBenefit.findIndex(
            (product) => product.sku === bestCostBenefit.sku
          );
          arrayWithPerfectForYouAndBestCostBenefit.splice(indexOfBestCostBenefit, 1);
          arrayWithPerfectForYouAndBestCostBenefit.splice(1, 0, bestCostBenefit);
        }

      }
      return arrayWithPerfectForYouAndBestCostBenefit;
    }
  },
};
</script>

<style lang="scss">
@import "./sass/main.scss";

.v-toast {

  z-index: 999999999 !important;

}

.invisible {
  display: none;
}

// Mobile
.page {
  background-color: $color-light-default;
  font-family: $font-family-default, sans-serif;
  font-size: $font-size-default-desktop;
  line-height: $line-height-default-desktop;
  color: $color-dark-default;

  .container-general {
    max-width: $bp-limit;

    .container {
      max-width: 100%;
      margin: 0 auto;

      display: flex;
      flex-direction: column;

      align-items: center;
    }
  }
}

.divider {
  margin: 38px 0 7px 0;
  border-top: 1px solid #8080803b;
  max-width: 1382px;
  width: 100%;
}

@media (max-width: $bp-mobile) {
  .center-text {
    text-align: center !important;
  }
}

// Desktop
.page {
  @media (min-width: $bp-mobile) {
    .container-general {
      width: 100%;
      margin: 0 auto;
    }
  }
}

.legal {
  box-sizing: border-box;
  font-size: smaller;
  line-height: 15px;
  margin: 2em;
  padding: 0 24px;
  width: 100%;
  text-align: justify;

  .texto-imagens {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    margin-bottom: 15px;

    span {
      font-size: 12px;
    }
  }

  .big_legal {
    font-size: 10px;
    line-height: 15px;
    border-top: 1px solid #8080803b;
    padding: 27px 0 15px 0;

    img {
      margin: -5px 16px 1px 0;
    }
  }


  p {
    margin-bottom: 10px;

    sup {
      top: 0px;
    }
  }
}

.legal.legal-cupom {
  margin: 2em 0 0 0;
}

.legal.legal-big-text {
  margin: 0;
}

.legal-coupon-mechanic {
  box-sizing: border-box;
  font-size: smaller;
  line-height: 15px;
  width: 100%;
  text-align: justify;
  border-top: 1px solid #8080803b;
  // border-bottom: 1px solid #8080803b;
  padding: 27px 0;

  p {
    text-align: center;
    font-size: 0.8rem;
    margin: 0;
    line-height: 1.5rem;
  }
}

.legal:has(.legal-coupon-mechanic) {
  margin-bottom: 0;
}

@media (max-width: $bp-mobile) {
  .legal-coupon-mechanic {
    p {
      text-align: justify;
    }
  }
}


.legal-coupon-mechanic-2 {
  box-sizing: border-box;
  font-size: smaller;
  width: 100%;
  text-align: justify;
  border-bottom: 1px solid #8080803b;

  p {
    text-align: center;
    font-size: 0.8rem;
    margin: 0;
    line-height: 1.5rem;
  }
}

.legal:has(.legal-coupon-mechanic-2) {
  margin-bottom: 0;
}

@media (max-width: $bp-mobile) {

  .legal {
    .big_legal{
      img{
        margin: 8px 16px 1px 0;
      }
    }
  }

  .legal-coupon-mechanic-2 {
    p {
      text-align: justify;
    }
  }

  ul.gnb__depth2 .gnb__depth2-dropdown-cta {
    display: flex;
    align-items: center;
    justify-content: right;
    width: 100%;
  }

  ul.gnb__depth2 .gnb__depth2-dropdown-cta svg.icon {
    display: block;
    position: initial;
    left: initial;
    top: initial;
    margin-right: 10px;
  }
}

// .legalCouponMechanicInForm {
// display: block;
// font-size: smaller;
// margin: 2em auto;
// border-bottom: 1px solid #0003;
// width: 100%;
// max-width: 1382px;
// text-align: center;

// p {

// }
// }


@media (max-width: $bp-mobile) {
  .almostFindingOut {
    display: none;
  }
}
</style>
